export const GA_FIRST_BET_CONSTANTS = {
    BETTING: 'betting',
    FIRST_BET_PLACEMENT: 'first bet placement',
    NOT_APPLICABLE: 'not applicable',
};
